$(document).ready(function () {
  $(".loginDropdown > a").click(function (e) {
    e.preventDefault(); // Prevent the default anchor behavior
    $(this).siblings(".dropDownItems").slideToggle(); // Only toggle the specific dropdown related to this link
  });

  // Close dropdowns when clicking outside
  $(document).click(function (e) {
    if (!$(e.target).closest(".loginDropdown").length) {
      $(".dropDownItems").slideUp();
    }
  });
  $(".title-content-wrapper").click(function () {
    $(".sub-menu.mega-menu-container").slideToggle();
  });
});
